export function formatDate(date: string | Date, locale?: string, options?: Record<string, string>) {
  return new Intl.DateTimeFormat(locale, options).format(new Date(date));
}
